import { create } from "zustand";

export type GamePhase = "menu" | "race" | "result";

export interface CarSpec {
  id: string;
  name: string;
  maxSpeed: number;
  accel: number;
  handling: number;
  /** Signature accent used in the menu preview so cards look distinct. */
  accent: string;
}

export const CARS: CarSpec[] = [
  { id: "neon", name: "Neon", maxSpeed: 320, accel: 4.5, handling: 1.1, accent: "#00ffff" },
  { id: "blade", name: "Blade", maxSpeed: 360, accel: 4.0, handling: 0.95, accent: "#ff00ff" },
  { id: "ghost", name: "Ghost", maxSpeed: 300, accel: 5.0, handling: 1.25, accent: "#00ff7f" },
];

export const CAR_COLORS: string[] = [
  "#00ffff",
  "#ff00ff",
  "#00ff7f",
  "#ff8800",
  "#ffff00",
  "#a020ff",
];

export interface LeaderboardEntry {
  rank: number;
  user_id: number;
  time_ms: number;
  car_id: string;
  is_me: boolean;
}

interface RaceState {
  phase: GamePhase;
  carId: string;
  color: string;
  finalPosition: number;
  finalTimeMs: number;
  leaderboard: LeaderboardEntry[];
  loadingLb: boolean;

  setCar: (id: string) => void;
  setColor: (c: string) => void;
  startRace: () => void;
  finishRace: (position: number, timeMs: number) => void;
  setLeaderboard: (entries: LeaderboardEntry[]) => void;
  setLoadingLb: (b: boolean) => void;
  backToMenu: () => void;
}

export const useRace = create<RaceState>((set) => ({
  phase: "menu",
  carId: CARS[0]!.id,
  color: CAR_COLORS[0]!,
  finalPosition: 0,
  finalTimeMs: 0,
  leaderboard: [],
  loadingLb: false,

  setCar: (id) => set({ carId: id }),
  setColor: (c) => set({ color: c }),
  startRace: () => set({ phase: "race", finalPosition: 0, finalTimeMs: 0 }),
  finishRace: (position, timeMs) =>
    set({ phase: "result", finalPosition: position, finalTimeMs: timeMs }),
  setLeaderboard: (entries) => set({ leaderboard: entries }),
  setLoadingLb: (b) => set({ loadingLb: b }),
  backToMenu: () => set({ phase: "menu" }),
}));
